import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import ScenariosSection from './components/ScenariosSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'luluca 官方落地页',
  url: 'https://luluca.com/',
  description: 'luluca 智能创作平台，AI 赋能创意表达，让设计不再有门槛。探索 luluca 的核心特色、使用场景与用户价值。',
  inLanguage: 'zh-CN',
  publisher: {
    '@type': 'Organization',
    name: 'luluca',
  },
};

export default function Home() {
  useEffect(() => {
    document.title = 'luluca官方落地页·探索luluca的全部精彩 | luluca官网';
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <ScenariosSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}